import { Zap, Droplets, PaintRoller, LayoutGrid, Hammer, Wrench, Truck, Sparkles } from "lucide-react";
import { FadeIn, SectionHeader } from "./Reveal";
import { scrollToId } from "../../lib/scroll";

const SERVICES = [
    { icon: Zap, name: "Elektryka", items: ["Instalacje elektryczne", "Naprawy", "Montaż osprzętu", "Wymiana gniazd", "Oświetlenie"] },
    { icon: Droplets, name: "Hydraulika", items: ["Instalacje wod-kan", "Naprawy", "Biały montaż", "Armatura", "Usuwanie awarii"] },
    { icon: PaintRoller, name: "Wykończenia", items: ["Malowanie", "Szpachlowanie", "Zabudowy GK", "Sufity"] },
    { icon: LayoutGrid, name: "Układanie płytek", items: ["Łazienki", "Kuchnie", "Tarasy", "Schody", "Podłogi"] },
    { icon: Hammer, name: "Montaż", items: ["Meble", "Drzwi", "Listwy", "Karnisze", "Oświetlenie", "Rolety"] },
    { icon: Wrench, name: "Drobne naprawy", items: ["Regulacje", "Skręcanie mebli", "Naprawy", "Konserwacje", "Prace techniczne"] },
    { icon: Truck, name: "Wywóz odpadów budowlanych", items: ["Gruz", "Odpady remontowe", "Stare meble", "Worki i big-bagi", "Utylizacja"] },
    { icon: Sparkles, name: "Sprzątanie mieszkań", items: ["Przygotowanie do remontu", "Opróżnianie lokali", "Wyniesienie rzeczy", "Zabezpieczenie powierzchni"] },
];

export default function Services() {
    return (
        <section id="uslugi" className="bg-white py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
                    <SectionHeader index="02" eyebrow="Nasze usługi" title="Jedna firma. Wszystkie prace." />
                    <FadeIn delay={0.15}>
                        <p className="max-w-sm text-sm leading-relaxed text-ink/55">
                            Od pojedynczego gniazdka po remont generalny — bierzemy na siebie całość,
                            żebyś nie musiał szukać pięciu różnych ekip.
                        </p>
                    </FadeIn>
                </div>
                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {SERVICES.map((s, i) => (
                        <FadeIn key={s.name} delay={(i % 3) * 0.08}>
                            <button
                                data-testid={`service-card-${i}`}
                                onClick={() => scrollToId("kontakt")}
                                className="group flex h-full w-full flex-col rounded-3xl border border-ink/8 bg-white p-8 text-left shadow-sm transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-gold/60 hover:shadow-[0_28px_60px_-24px_rgba(10,10,10,0.18)]"
                            >
                                <div className="mb-7 flex items-start justify-between">
                                    <div className="rounded-2xl bg-ink p-3.5 text-gold transition-[background-color,transform] duration-500 group-hover:rotate-[-6deg] group-hover:bg-gold group-hover:text-ink">
                                        <s.icon className="h-6 w-6" strokeWidth={1.8} />
                                    </div>
                                    <span className="font-mono text-xs font-semibold tracking-[0.25em] text-ink/25 transition-colors duration-500 group-hover:text-gold">
                                        0{i + 1}
                                    </span>
                                </div>
                                <h3 className="font-display text-2xl font-bold tracking-tight text-ink">{s.name}</h3>
                                <ul className="mt-5 flex flex-wrap gap-2">
                                    {s.items.map((item) => (
                                        <li
                                            key={item}
                                            className="rounded-full bg-mist px-3.5 py-1.5 text-xs font-medium text-ink/60 transition-colors duration-300 group-hover:bg-gold/15 group-hover:text-ink"
                                        >
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </button>
                        </FadeIn>
                    ))}
                </div>
            </div>
        </section>
    );
}
